module.exports = __webpack_public_path__ + "static/carefriends-03342ca6d998a6250c287a32c50bedb2.png";